import React, {memo} from 'react';
import {View} from 'react-native';

import { StyleSheet } from 'react-native';
import AccountDeletionRequest from '../profile-deletion/AccountDeletionRequest';
import AccountPermanentDelete from '../profile-deletion/AccountPermanentDelete';

interface AccountPermanentDeleteModalProps {
  onCancel: () => void;
  onDoctorDelete?: () => void;
  patientId?: string;
  forDoctor?: boolean;
  accountOwner?: boolean;
}

function AccountPermanentDeleteModal(props: AccountPermanentDeleteModalProps) {

  return (
    <View style={rneStyles.root}>
      <AccountPermanentDelete
        onCancel={props.onCancel}
        onDoctorDelete={props.onDoctorDelete}
        patientId={props.patientId}
        forDoctor={props.forDoctor}
        accountOwner={props.accountOwner}
      />
    </View>
  );
}

const rneStyles = StyleSheet.create(({
  root: {
    maxWidth: 600,
    padding: 32,
    justifyContent: 'center',
  },
  actionContainer: {
    marginTop: 80,
    justifyContent: 'center',
    flexDirection: 'row',
  },
  buttonContainer: {
    marginRight: 16,
  },
  buttonStyle: {
    width: 120,
  },
  overlayContainer: {
    borderRadius: 20,
  },
}));

export default memo(AccountPermanentDeleteModal);
